// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function SimpleBlogCard({ item, image, title, description, action }) {
  return (
    <Card
      sx={{
        height: "360px", // Set a fixed height for the card
        display: "flex",
        maxWidth: "300px",
        flexDirection: "column",
        justifyContent: "space-between",
        margin: "auto",
      }}
    >
      {/* Image Section */}
      <MDBox
        position="relative"
        borderRadius="lg"
        sx={{
          height: "160px", // Fixed height for the image container
          overflow: "hidden",
        }}
      >
        <MDBox
          component="img"
          src={image}
          alt={title}
          borderRadius="lg"
          shadow="md"
          width="100%"
          height="100%"
          sx={{
            objectFit: "cover", // Ensures the image covers the container
          }}
        />
      </MDBox>

      {/* Content Section */}
      <MDBox p={3} sx={{ flexGrow: 1 }}>
        <MDTypography
          display="inline"
          variant="h5"
          textTransform="capitalize"
          fontWeight="bold"
        >
          {title}
        </MDTypography>
        <MDBox mt={1} mb={2} sx={{ height: "40px", overflow: "hidden" }}>
          <MDTypography
            variant="body2"
            component="p"
            color="text"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // Ensures a max of 2 lines for the description
              textOverflow: "ellipsis",
            }}
          >
            {description}
          </MDTypography>
        </MDBox>
      </MDBox>

      {/* Action Section */}
      <MDBox p={2}>
        {action.type === "external" ? (
          <MuiLink href={action.route} target="_blank" rel="noreferrer">
            <MDButton
              variant={action.variant ? action.variant : "contained"}
              color={action.color ? action.color : "dark"}
              fullWidth
            >
              {action.label}
            </MDButton>
          </MuiLink>
        ) : (
          <Link to={action.route} state={{ project: item }}>
            <MDButton
              variant={action.variant ? action.variant : "contained"}
              color={action.color ? action.color : "dark"}
              fullWidth
            >
              {action.label}
            </MDButton>
          </Link>
        )}
      </MDBox>
    </Card>
  );
}

// Typechecking props for the SimpleBlogCard
SimpleBlogCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
      "default",
    ]),
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default SimpleBlogCard;
